import { generateClient } from "aws-amplify/api";
import i18n from "i18n";
import store from "store";

const TWIIK_CLIENT_ID = process.env.REACT_APP_TWIIK_CLIENT_ID;

const getPropByPath = (object, path, defaultValue) => {
  const _path = Array.isArray(path) ? path : path.split(".");
  if (object && _path.length) {
    return getPropByPath(object[_path.shift()], _path, defaultValue);
  }
  return object === undefined ? defaultValue : object;
};

const client = generateClient();

export default async function doRequest(
  requestMeta,
  successPath,
  useBasicAuth = false
) {
  const language = i18n.language || "en";
  let result;
  try {
    if (useBasicAuth) {
      const clientId = `${TWIIK_CLIENT_ID}`;
      result = await client.graphql(requestMeta, {
        Authorization: `APIKEY ${clientId}`,
        "Accept-Language": language,
      });
    } else {
      const token = store.getState().auth.accessToken;
      result = await client.graphql(requestMeta, {
        Authorization: `BEARER ${token}`,
        "Accept-Language": language,
      });
    }
  } catch (error) {
    if (error?.data) {
      result = error;
    } else {
      throw error;
    }
  }
  if (successPath) {
    const data = getPropByPath(result, successPath);
    if (data?.errorMessage) {
      throw data.errorMessage;
    }
    return data;
  } else if (result.errorMessage) {
    throw result.errorMessage;
  }
  return result;
}
